module.exports = __webpack_public_path__ + "img/francoeur_4_cover.a1b40851.jpg";